var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.75 6.857a.75.75 0 0 0-1.5 0V9.25H6.857a.75.75 0 1 0 0 1.5H9.25v2.393a.75.75 0 0 0 1.5 0V10.75h2.393a.75.75 0 0 0 0-1.5H10.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0",
    clipRule: "evenodd"
  })));
};
export { SvgPlusCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTAuNzUgNi44NTdhLjc1Ljc1IDAgMDAtMS41IDBWOS4yNUg2Ljg1N2EuNzUuNzUgMCAxMDAgMS41SDkuMjV2Mi4zOTNhLjc1Ljc1IDAgMDAxLjUgMFYxMC43NWgyLjM5M2EuNzUuNzUgMCAwMDAtMS41SDEwLjc1VjYuODU3eiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxMGMwIDUuNTIzLTQuNDc3IDEwLTEwIDEwUzAgMTUuNTIzIDAgMTAgNC40NzcgMCAxMCAwczEwIDQuNDc3IDEwIDEwem0tMS41IDBhOC41IDguNSAwIDExLTE3IDAgOC41IDguNSAwIDAxMTcgMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";